import React, { useState } from 'react';
import { useRouter } from 'next/router';
import { useSelector, useDispatch } from "react-redux";
import * as actionTypes from "@redux/actionTypes";
import { GobackTestDriveIcon, TimeElapsedTestDriveIcon, LikeTestDriveIcon, UnLikeTestDriveIcon, SuccessTestDriveIcon } from '@util/svgicon';
import { toast } from "react-toastify";
import { updateFeedBack, rideTerminate } from '@services/api';
import toastErrorMessages from "@util/toastErrorMessage";
import TestdriveSuccessLifePointImage from '@images/playgame/testdriveSuccessLifePoint.png';
import ShoppingCartIcon from '@images/playgame/shopping_cart.svg';
import MdiCreationIcon from '@images/playgame/mdi_creation.svg';
import { safeLocalStorage } from "@utils/localstorage";
const ENDTIME = '15:00'

const TestDriveSuccess = () => {
    const router = useRouter();
    const dispatch = useDispatch();
    const tournamentData = safeLocalStorage.getItem('tournamentData')
    const scanCheckPointList = useSelector((state) => state.testDriveDetails.scanCheckPointList)
    const allScanCheckpoint = useSelector((state) => state.testDriveDetails.allScanCheckpoint)
    const timeLeft = useSelector((state) => state.testDriveDetails.timeLeft)
    const testDriveRideId = useSelector((state) => state.testDriveDetails.testDriveRideId);
    const user = useSelector((state) => state?.setUserDetails?.user)
    const [userFeedback, setUserFeedback] = useState('');

    const gotoTestDrive = async () => {
        testRideTerminateHandler();
        await new Promise((resolve) => setTimeout(resolve, 2000));
        window.location.replace("/testdrive");
        // TODO: @franciscomasi To use Navigator we need to clean Redux properly
        // navigate(`/testdrive`);
    }

    const gotoOpenWorldDrive = async () => {
        safeLocalStorage.setItem('openWorldGame', true)
        testRideTerminateHandler();
        await new Promise((resolve) => setTimeout(resolve, 2000));
        window.location.replace("/dashboard");
        // TODO: @franciscomasi To use Navigator we need to clean Redux properly
        // navigate(`/dashboard`);
    }

    const handleChangeTextArea = (event) => {
        setUserFeedback(event.target.value);
    }

    const handleSubmitFeedback = async () => {
        if (userFeedback && testDriveRideId) {
            const feedback = {
                "ride": {
                    "feedback": userFeedback,
                    "status": "ended"
                }
            }
            const response = await updateFeedBack(feedback, testDriveRideId)
            if (response) {
                toast.success(toastErrorMessages.feedbackSubmittedSuccess, { position: "top-right" });
                setUserFeedback("")
                if (scanCheckPointList?.length === allScanCheckpoint?.length && scanCheckPointList?.length !== 0 && allScanCheckpoint?.length !== 0 && timeLeft <= ENDTIME) {
                    gotoOpenWorldDrive()
                } else {
                    gotoTestDrive()
                }
            }
        } else {
            toast.error('Please add your feedback.', { position: "top-right" });
        }
    }

    const testRideTerminateHandler = async () => {
        dispatch({
            type: actionTypes.GPT_ERROR_TOAST,
            payload: false
        })
        dispatch({
            type: actionTypes.GPT_MESSAGE_TOAST,
            payload: false
        })
        await rideTerminate(testDriveRideId)
        safeLocalStorage.removeItem(`agoratoken_${tournamentData?.deviceId}`)
        safeLocalStorage.removeItem(`keyBinding_${user?.id}`)
        safeLocalStorage.removeItem(`score_${user.id}`)
        safeLocalStorage.removeItem(`keyboradKey`)
        safeLocalStorage.removeItem(`WheelKey`)
        safeLocalStorage.removeItem(`RemoteKey`)
        safeLocalStorage.removeItem(`selectControllerName`)
        safeLocalStorage.removeItem(`headlight`)
        safeLocalStorage.removeItem(`tournamentData`)
    }

    const buyGamePassHandler = async () => {
        safeLocalStorage.setItem('openWorldGame', true)
        testRideTerminateHandler();
        await new Promise((resolve) => setTimeout(resolve, 2000));
        window.location.replace('/buy-gamepass');
        // TODO: @franciscomasi To use Navigator we need to clean Redux properly
        // navigate('/buy-gamepass');
    };

    const isTestdriveComplected = ((scanCheckPointList?.length === allScanCheckpoint?.length && scanCheckPointList?.length !== 0 && allScanCheckpoint?.length !== 0 && timeLeft <= ENDTIME) || (scanCheckPointList?.length >= 7 && timeLeft <= ENDTIME))

    return (
        <div className="testdrive-success-model" style={{ maxHeight: isTestdriveComplected ? '700px' : '520px' }} >
            <div className='sucess-topheader-container'>
                <p className='thanks-testdrive-letter'>Thanks for test driving!</p>
                {
                    isTestdriveComplected ?
                        <div className='back-dash-test-container'>
                            <div className='testdrive-section' onClick={gotoOpenWorldDrive}>
                                <GobackTestDriveIcon />
                                <p className='testdrive-letter'>Continue to Open-World Game</p>
                            </div>
                        </div>
                        :
                        <div className='back-dash-test-container'>
                            <div className='testdrive-section' onClick={gotoTestDrive}>
                                <GobackTestDriveIcon />
                                <p className='testdrive-letter'>Try Again</p>
                            </div>
                        </div>
                }
            </div>
            <div className='success-exp-container'>
                {
                    isTestdriveComplected ?
                        <div className='success-container'>
                            <div className='success-test-title'>
                                <p className='congratulation-letter'>Congratulations!</p>
                            </div>
                            <p className='sucess-testdrive-msg'>You found {scanCheckPointList?.length} cones out of {allScanCheckpoint?.length}!</p>
                            <div className='succes-time-elapsed-container'>
                                <div className='time-elapsed-icon'>
                                    <SuccessTestDriveIcon />
                                </div>
                                <div className='timer-time-show-section'>
                                    <p className='succes-time-Elapsed-number'>{timeLeft}</p>
                                    <div className='time-elapsed-lettter-section'>
                                        <p className='succes-time-elapsed-letter'>Completion Time</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        <div className='success-container'>
                            <div className='loss-test-title'>
                                <p className='maybe-letter'>Maybe next time!</p>
                            </div>
                            <p className='loss-testdrive-msg'>You found {scanCheckPointList?.length} cones out of {allScanCheckpoint?.length}. Please try the test drive experience again in order to unlock the Open-World Game.</p>
                            <div className='time-elapsed-container'>
                                <div className='time-elapsed-icon'>
                                    <TimeElapsedTestDriveIcon />
                                </div>
                                <div className='timer-time-show-section'>
                                    <p className='time-Elapsed-number'>15:00</p>
                                    <div className='time-elapsed-lettter-section'>
                                        <p className='time-elapsed-letter'>Time Elapsed</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                }
                <div className='experience-container'>
                    <p className='testdrive-feedback-info'>Would you recommend this experience? We'd love to hear any feedback from you!</p>
                    <div className='like-unlike-container'>
                        <LikeTestDriveIcon />
                        <UnLikeTestDriveIcon />
                    </div>
                    <div className='textarea-container'>
                        <textarea className='testdrive-feedback-write-msg-container' placeholder='Type what you want to say here... (Optional)' value={userFeedback} onChange={handleChangeTextArea} ></textarea>
                    </div>
                    <button className='mis_com_details_submit_feedback' onClick={handleSubmitFeedback}>
                        <p className='mis_com_sumbit-letter'>Submit feedback</p>
                    </button>
                </div>
            </div>
            {
                isTestdriveComplected &&
                <div className='w-full h-full flex p-[32px] items-start gap-[16px] rounded-[16px] border-[1px] border-[solid] border-[#D5D9FF] bg-[#F2F2FF]'
                    style={{
                        backgroundImage: `url(${TestdriveSuccessLifePointImage})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'right'
                    }}
                >
                    <div className='w-full flex flex-col items-start gap-[16px]'>
                        <div className='flex items-center gap-[8px]'>
                            <img src={MdiCreationIcon} alt='Mdi Creation' className='w-[20px] h-[20px]' />
                            <p className='text-[#0A6AF3] text-center text-[28px] not-italic font-semibold leading-[28px] tracking-[-1.68px]'>Unlock more in Driving School!</p>
                        </div>
                        <p className='w-[65%] before:text-[#393939] text-[16px] not-italic font-medium leading-[22px] tracking-[-0.32px]'>Dive into endless adventures in the EarthRovers Driving School! Explore selected countries, enjoy exciting rides, and travel virtually anywhere you desire. Your passport to boundless fun awaits – get the pass now!</p>
                        <div className='flex items-start gap-[8px]'>
                            <button className='flex pl-[8px] pr-[12px] py-[6px] items-center gap-[6px] rounded-[1000px] border-[1px] border-solid border-[#6E93FF] bg-[#0A6AF3]' onClick={buyGamePassHandler}>
                                <img src={ShoppingCartIcon} alt='Shopping Cart' className='w-[20px] h-[20px]' />
                                <p className='text-[#FFF] text-center text-[16px] not-italic font-semibold leading-[normal] tracking-[-0.64px]'>Get a gamepass now!</p>
                            </button>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export default TestDriveSuccess